export const excludeMenuList = ['online-course', 'video'];
// export const gradeValueText = true;
// export const gradeList = [
//     '第 1 個課程－共 10 堂',
//     '第 1 個課程－共 12 堂',
//     '第 1 個課程－共 16 堂',
//     '第 2 個課程－共 10 堂',
//     '第 2 個課程－共 12 堂',
//     '第 2 個課程－共 16 堂',
//     '第 3 個課程－共 10 堂',
//     '第 3 個課程－共 12 堂',
//     '第 3 個課程－共 16 堂',
//     '第 4 個課程－共 10 堂',
//     '第 4 個課程－共 12 堂',
//     '第 4 個課程－共 16 堂',
//     '第 5 個課程－共 10 堂',
//     '第 5 個課程－共 12 堂',
//     '第 5 個課程－共 16 堂',
//     '第 6 個課程－共 10 堂',
//     '第 6 個課程－共 12 堂',
//     '第 6 個課程－共 16 堂',
//     '第 7 個課程－共 10 堂',
//     '第 7 個課程－共 12 堂',
//     '第 7 個課程－共 16 堂',
//     '第 8 個課程－共 10 堂',
//     '第 8 個課程－共 12 堂',
//     '第 8 個課程－共 16 堂',
//     '第 9 個課程－共 10 堂',
//     '第 9 個課程－共 12 堂',
//     '第 9 個課程－共 16 堂',
//     '第 10 個課程－共 10 堂',
//     '第 10 個課程－共 12 堂',
//     '第 10 個課程－共 16 堂',
//     '第 11 個課程－共 10 堂',
//     '第 11 個課程－共 12 堂',
//     '第 11 個課程－共 16 堂',
//     '第 12 個課程－共 10 堂',
//     '第 12 個課程－共 12 堂',
//     '第 12 個課程－共 16 堂'
// ];

